<script lang="ts">
    import Vue from "vue";
    import { Component } from 'vue-facing-decorator';
    import { strCompare } from "@common/Common";
    import { CriteriaPanelistsManagerViewModel } from "@Evaluation/CriteriaSurveys/Components/CriteriaPanelistsManager";
    import { dynamicUiRoutes } from "@common/dynamicUiRoutes";

    @Component({
        props: {
            viewModel: {
                type: Object,
                required: true
            }
        }
    })
    export default class CriteriaPanelistsManager extends Vue
    {
        get vm(): CriteriaPanelistsManagerViewModel { return this.$props.viewModel as CriteriaPanelistsManagerViewModel; }

        get opened() : boolean { return this.vm?.opened ?? false; }
        
        get workspaceId() { return this.vm.workspaceId; }
        get projectId() { return this.vm.projectId; }
        get initialized(): boolean { return this.vm.data != null; }
        get projectUsers() { return this.vm.data?.ProjectUsers; }
        get tags() { return this.vm.data?.ProjectUsersTags; }
        get url_PeoplePage(): string { return dynamicUiRoutes.ProjectUsers_PeoplePage(this.$route, this.workspaceId, this.projectId); }

        tag: string | null = null;
        searchPhrase: string | null = null;

        get projectUsersView()
        {
            if (this.projectUsers == null)
            {
                return null;
            }

            let view = this.projectUsers.filter(a => a.IsArchived === false);

            if (this.searchPhrase)
            {
                const phrase = this.searchPhrase.toLowerCase();
                view = view.filter(a => (`${a.Name} ${a.Email}`).toLowerCase().indexOf(phrase) > -1);
            }

            if (this.tag)
            {
                view = view.filter(a => a.Tags.indexOf(this.tag) > -1);
            }

            view = view.sort((a, b) => strCompare(a.Name.toLowerCase(), b.Name.toLowerCase()));

            return view;
        }

        handleIncludePanelist(puId: number)
        {
            this.$emit("include-panelist", puId);
        }

        close()
        {
            this.vm.close();
        }
    }
</script>

<template>
    <div class="modal-mask" v-if="opened">
        <div class="modal-wrapper">
            <div class="modal-dialog modal-xl modal-dialog-scrollable">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Add panelists</h5>
                        <button type="button" class="close" @click="close">&times;</button>
                    </div>

                    <div class="modal-body" style="min-height: 300px;">
                        <h3 v-if="!initialized"><i class="fa fa-spinner fa-spin"></i> Loading...</h3>

                        <div v-if="initialized">

                            <div v-if="projectUsers.length === 0">
                                <p class="lead">
                                    You currently have no Respondents set-up in the software.
                                    Please go to the <a class="text-primary" v-sanitizedHref="url_PeoplePage" target="_blank">People section</a> to upload names & emails.
                                </p>
                            </div>

                            <div v-if="projectUsers.length > 0">

                                <nav class="navbar navbar-light navbar-expand-md bg-light" role="navigation">
                                    <form class="form-inline my-2 my-lg-0 ml-auto" role="search">
                                        <input class="form-control form-control-sm mr-sm-2" type="search" placeholder="Search" v-model="searchPhrase">
                                    </form>
                                    <form class="form-inline my-2 my-lg-0 ">
                                        <div class="dropdown">
                                            <button class="btn btn-sm btn-outline-secondary dropdown-toggle" type="button" data-toggle="dropdown">
                                                <span>Filter by: {{tag ?? "Show all"}}</span>
                                            </button>
                                            <div class="dropdown-menu dropdown-menu-right">
                                                <a class="dropdown-item" @click="tag = null">Show all</a>
                                                <h6 class="dropdown-header">By tag:</h6>
                                                <a class="dropdown-item" v-for="t in tags" @click="tag = t">{{t}}</a>
                                            </div>
                                        </div>
                                    </form>
                                </nav>

                                <table class="table">
                                    <tbody>
                                        <tr v-for="pu in projectUsersView" :key="pu.ProjectUserId">
                                            <td>
                                                <p class="fg-color-gray mb-0 mt-1">
                                                    <span>{{pu.Name}}</span>
                                                </p>
                                                <small class="text-muted" v-if="pu.HasEmail">{{pu.Email}}</small>
                                                <small class="text-danger" v-if="!pu.HasEmail">Email not provided</small>
                                            </td>
                                            <td>
                                                <span class="badge badge-secondary mr-1" v-for="t in pu.Tags" :key="t">{{t}}</span>
                                            </td>
                                            <td style="width: 80px;">
                                                <button type="button" class="btn btn-outline-secondary" @click="handleIncludePanelist(pu.ProjectUserId)" :disabled="pu.Included">
                                                    {{pu.Included ? "Added" : "Add"}}
                                                </button>
                                            </td>
                                        </tr>
                                    </tbody>
                                </table>

                            </div>
                        </div>
                    </div>

                    <div class="modal-footer">
                        <a class="btn btn-outline-secondary" v-sanitizedHref="url_PeoplePage" target="_blank">Add people</a>
                        <button @click="close" type="button" class="btn btn-outline-secondary">Close</button>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<style scoped>
</style>